import { useEffect, useState } from "react";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

export default function Admin() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("igreen_admin_token");
    if (!token) {
      setChecking(false);
      return;
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((u) => {
        if (!u) localStorage.removeItem("igreen_admin_token");
        setUser(u);
      })
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  const logout = () => {
    localStorage.removeItem("igreen_admin_token");
    setUser(null);
  };

  if (checking) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#04120E]" data-testid="admin-loading">
        <div className="w-10 h-10 rounded-full border-2 border-[#00E676]/30 border-t-[#00E676] animate-spin" />
      </div>
    );
  }

  return user ? <AdminDashboard user={user} onLogout={logout} /> : <AdminLogin onLogin={setUser} />;
}
